module.exports = __webpack_public_path__ + "img/Vic_Profile.f3f03dea.jpg";